const IMAGE_KEY_PREFIX = 'streamrtv-img:';
function imageStorageKey(imageId) {
    return `${IMAGE_KEY_PREFIX}${imageId}`;
}
export class StoredMediaStore {
    getPersistedImage(id) {
        try {
            const raw = localStorage.getItem(imageStorageKey(id));
            if (!raw)
                return undefined;
            const parsed = JSON.parse(raw);
            if (parsed.name && parsed.dataUrl)
                return parsed;
        }
        catch {
            // corrupt entry
        }
        return undefined;
    }
    persistImage(id, name, dataUrl) {
        try {
            localStorage.setItem(imageStorageKey(id), JSON.stringify({ name, dataUrl }));
        }
        catch {
            // localStorage may be full
        }
    }
    removePersistedImage(id) {
        try {
            localStorage.removeItem(imageStorageKey(id));
        }
        catch {
            // ignore
        }
    }
    getNextImageId() {
        let max = 0;
        try {
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key?.startsWith(`${IMAGE_KEY_PREFIX}image:`)) {
                    const num = Number.parseInt(key.slice(`${IMAGE_KEY_PREFIX}image:`.length), 10);
                    if (!Number.isNaN(num) && num > max)
                        max = num;
                }
            }
        }
        catch {
            // localStorage not available
        }
        return max + 1;
    }
}
